import { flow } from 'lodash'
import { FormValues, parseNilToEmptyString, pickOrCreate } from 'utils-next/forms'
import * as Yup from 'yup'

import { ApiCorporateData, Corporate } from '../../../../../../../../entities-next/corporate'

const keysFromCorporate = [
  'id',
  'name',
  'status',
  'enabledFeatures',
  'demo',
  'logoUrl',
  'websiteUrl',
  'adminNotes',
  'userGroupId',
  'userGroup',
  'seatsLimit',
  'seatsUsed',
]

export type CorporateFormData = FormValues<
  Pick<
    Corporate,
    | 'id'
    | 'name'
    | 'status'
    | 'enabledFeatures'
    | 'demo'
    | 'logoUrl'
    | 'websiteUrl'
    | 'adminNotes'
    | 'userGroupId'
    | 'userGroup'
    | 'seatsLimit'
    | 'seatsUsed'
  >
>

export const corporateDataFormValidationSchema = Yup.object().shape({
  name: Yup.string().required(),
  status: Yup.mixed().required(),
})

export function parseCorporateToCorporateFormData({ ...corporateData }: Corporate): CorporateFormData {
  const formCorporateData = flow(pickOrCreate(keysFromCorporate), parseNilToEmptyString)(corporateData)
  return {
    ...formCorporateData,
  }
}

export async function parseCorporateFormDataToCorporate({
  userGroup,
  ...otherData
}: CorporateFormData): Promise<ApiCorporateData> {
  return {
    ...otherData,
    userGroupId: otherData.userGroupId && Number(otherData.userGroupId) > 0 ? Number(otherData.userGroupId) : undefined,
  }
}
